// extracted by mini-css-extract-plugin
module.exports = {"quantity":"style_quantity__3FuWN"};